module.exports = __webpack_public_path__ + "img/kuwait.0058e237.svg";